import { Timestamp, timestampDate } from "@bufbuild/protobuf/wkt"
import moment from "moment"

export const formatTimestampSince = (timestamp?: Timestamp): string => {
  return timestamp ? moment(timestampDate(timestamp)).fromNow() : "never"
}
